import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
// import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import red from '@material-ui/core/colors/red';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import Grid from '@material-ui/core/Grid';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';

const styles = theme => ({
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    actions: {
        display: 'flex',
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: red[500],
    },
});

class RecipeReviewCard extends React.Component {
    state = { expanded: false };

    handleExpandClick = () => {
        this.setState(state => ({ expanded: !state.expanded }));
    };

    render() {
        const { classes, post } = this.props;
        // console.log(post)
        // console.log(post.explanation)
        // console.log("lkol",post.is_active)
        return (
            <Card className={' post-cards'}>
                <CardContent className='postcontent'>
                    <div className='top-content-post'>
                        <div className='post-title-factory' >
                            <span className="factory-name">
                                {post.prices['0'].factory.name}
                            </span>
                        </div>
                        <div className='post-date-and-city'>
                            <div className="city-state" >
                                <span className="sity-name">
                                    شهرستان :
                                    <span>{post.prices['0'].factory.city.name}</span>
                                </span>
                                <span className="state-name">
                                    استان :
                                    <span>{post.prices['0'].factory.state.name}</span>
                                </span>
                            </div>
                          
                            <div className='post-situation'>
                                {post.is_active !== 1 &&
                                    <div>
                                        <span className="post-status">
                                            وضعیت :
                                    {post.statuses.map((status, i) =>
                                                <span className="post-status-name" key={i}>
                                                    {status.name}
                                                </span>
                                            )}
                                        </span>
                                    </div>
                                }    
                                {
                                
                                post.explanation !== null &&
                                post.explanation !== "" &&                      
                                <div className="explane-detail-div">
                                    <span className="contents">
                                        {post.explanation}
                                    </span>
                                </div>
                                }
                            </div>
                        {/* } */}
                            <div className="date-from-to" >
                                <span className="post-dates">
                                    <span className='total-from-date'>
                                        <span className='post-credit-from'>
                                            تاریخ اعتبار از :
                                        </span>
                                        <span className='post-credit-content'>
                                            {post.credit_date_shamsi}
                                        </span>
                                    </span>
                                    {post.credit_date_from !== null &&
                                        <span className='total-from-date'>
                                            <span className='post-credit-from'>
                                                تاریخ اعتبار تا :
                                            </span>
                                            <span className='post-credit-content'>
                                                {post.credit_date_from_shamsi.substring(0, 11)}
                                            </span>
                                        </span>
                                    }
                                </span>
                            </div>
                        </div>
                        
                    </div>
                    
                    <hr className='post-border' />
                    
                    {/* {post.is_active !== 1 &&
                        <div className="postmaintitle titles" >
                            درجه ها :
                        </div>
                    } */}
                    {post.is_active !== 1 &&
                        post.for_all_grades === 1 ?
                        <div className="post-content">
                            <div className="grades-for-all">
                                <div className='allgradesin'>
                                    {post.prices_sorted.map((degree, i) => {
                                        // console.log(degree.price)
                                        // console.log('test')
                                        if (Number(degree.price) !== 0)
                                            return (
                                                <div className='eachgradeall' key={i}>
                                                    <div className="post-degree-for-all" >
                                                        <span className="deg-all-name">
                                                            {degree.grade.name}
                                                        </span>
                                                        :
                                                        <span className="price">
                                                            {degree.price}
                                                        </span>
                                                    </div>
                                                </div>
                                            )
                                        return true;
                                    }
                                    )}
                                </div>
                            </div>
                            {
                                post.prices[0].diffrence_rates_name.length !== 0 &&
                                <div>
                                    <hr className='post-border' />
                                    <ExpansionPanel className='expanel-diff'>
                                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={'expanel-diff-sum'}>
                                            <div className='ex-head-diff'>
                                                <div className="titles" >
                                                    لیست کمک کرایه ها :
                                                </div>
                                            </div>
                                        </ExpansionPanelSummary>
                                        <ExpansionPanelDetails className='expanel-diff-detail'>
                                            {post.prices[0].diffrence_rates_name.map((diff, i) =>
                                                <div key={i} className='diffrentRateDiv'>
                                                    <div className='diffTitle'>
                                                        <p className="newpdiff" >
                                                        قیمت قراضه از مبدا بارگیری شهرهای زیر ،
                                                        <span className='diff-rate-ex'>
                                                        {diff.rate}
                                                        </span>
                                                        تومان بالاتر محاسبه میشود.
                                                        </p>
                                                    </div>
                                                    <div className='diffcontcity'>
                                                        {
                                                            diff.info.map((city, i) =>
                                                                <span className='city-name' key={i}>
                                                                    {city.name}
                                                                </span>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            )}
                                        </ExpansionPanelDetails>
                                    </ExpansionPanel>
                                </div>
                            }
                        </div>
                        :
                        post.is_active !== 1 &&
                        <div className="grades-for-each">
                            {post.prices_sorted.map((degree, i) =>
                                <div className="post-degree-for-each" key={i}>
                                    {degree.price !== 0 &&
                                        <div className='each-grades'>
                                            <span className="deg-each-name">
                                                {degree.grade.name} 
                                            </span>
                                        :
                                        <span className="price">
                                            {degree.price}
                                        </span>
                                        </div>
                                    }
                                    {degree.diffrence_rates_name.length !== 0 &&
                                        <div className='each-diffs'>                                            
                                            <ExpansionPanel key={i} className='expanel-diff'>
                                                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={'expanel-diff-sum'}>
                                                <div className='ex-head-diff'>
                                                    <div className="titles" >
                                                    لیست کمک کرایه ها :
                                                </div>
                                            </div>
                                                    </ExpansionPanelSummary>
                                                    <ExpansionPanelDetails className='expanel-diff-detail'>
                                            {degree.diffrence_rates_name.map((diff, i) =>
                                                             <div key={i} className='diffrentRateDiv'>
                                                             <div className='diffTitle'>
                                                             <p className="newpdiff" >
                                                        قیمت قراضه از مبدا بارگیری شهرهای زیر ،
                                                        <span className='diff-rate-ex'>
                                                        {diff.rate}
                                                        </span>
                                                        تومان بالاتر محاسبه میشود.
                                                        </p>
                                                             </div>
                                                        {diff.info.map((city, i) =>
                                                            <span className='city-name' key={i}>
                                                                {city.name}
                                                            </span>
                                                        )}
                                                        </div>
                                            )}
                                            </ExpansionPanelDetails>
                                            </ExpansionPanel>
                                        </div>
                                    }
                                </div>
                            )}
                        </div>
                    }
                    {post.is_active !== 1 &&
                    <hr className='post-border' />
                    }
                    <div className="post-bottom" >
{post.prices['0'].factory.categories.length !== 0 &&
                        <div className="post-category" >
                            <p className="category-names">
                                <span className='title-cat'>
                                    رسته :
                                </span>
                                {post.prices['0'].factory.categories.map((cat, i) =>
                                    <span key={i} className='content-cat raste-span'>
                                        {cat.name}
                                    </span>
                                )}
                            </p>
                        </div>
                        }
                        <div className="factory-areas" >
                            <p className="area-names">
                                <span className='title-cat'>
                                    ناحیه :
                                </span>
                                {post.prices['0'].factory.areas.map((area, i) =>
                                    <span key={i} className='content-area raste-span'>
                                        {area.name}
                                    </span>
                                )}
                            </p>
                        </div>
                        <div className="other-details">
                        <IconButton
                        className={classnames(classes.expand, {
                            [classes.expandOpen]: this.state.expanded,
                        })+" iconbut"}
                        onClick={this.handleExpandClick}
                        aria-expanded={this.state.expanded}
                        aria-label="جزئیات"
                            >
                                اطلاعات بیشتر
                        <ExpandMoreIcon />
                    </IconButton>
                        </div>
                    </div>
                </CardContent>
                {/* <CardActions className={classes.actions} disableActionSpacing>
                    
                </CardActions> */}
                <Collapse in={this.state.expanded} timeout="auto" unmountOnExit className="collapse-post">
                    <CardContent>
                        <div className="more-detail-div">
                            <span className="titles">
                                کد رهگیری :
                            </span>
                            <span className="contents">
                                {post.trans_code}
                            </span>
                        </div>
                        {post.discription !== "" &&
                            <div className="more-detail-div">
                                <span className="titles">
                                    توضیحات :
                            </span>
                                <span className="contents">
                                    {post.discription}
                                </span>
                            </div>
                        }
                        {post.prices['0'].factory.address !== null &&
                            <div className="more-detail-div">
                                <span className="titles">
                                    آدرس کارخانه :
                            </span>
                                <span className="contents">
                                    {post.prices['0'].factory.address}
                                </span>
                            </div>
                        }
                        {post.prices['0'].factory.tell !== null &&
                            <div className="more-detail-div">
                                <span className="titles">
                                    تلفن کارخانه :
                            </span>
                                <span className="contents">
                                    {post.prices['0'].factory.tell}
                                </span>
                            </div>
                        }
                        {post.prices['0'].factory.conditions !== null &&
                            <div className="more-detail-div">
                                <span className="titles">
                                    شرایط خاص :
                            </span>
                                <span className="contents">
                                    {post.prices['0'].factory.conditions}
                                </span>
                            </div>
                        }
                        {post.prices['0'].factory.drop_time !== null &&
                            <div className="more-detail-div">
                                <span className="titles">
                                    ساعات تخلیه :
                            </span>
                                <span className="contents">
                                    {post.prices['0'].factory.drop_time}
                                </span>
                            </div>
                        }
                        {post.prices['0'].factory.forbiddens.length !== 0 &&
                            <div className="more-detail-div">
                                <span className="titles">
                                    موارد ممنوعه :
                            </span>
                                <span className="contents">
                                    {post.prices['0'].factory.forbiddens.map((forbid, i) =>
                                        <span className='forbid' key={i}>
                                            {forbid.name}
                                        </span>
                                    )}
                                </span>
                            </div>
                        }
                        {post.prices['0'].factory.code !== null &&
                            <div className="more-detail-div">
                                <span className="titles">
                                    شناسه کارخانه :
                            </span>
                                <span className="contents">
                                    {post.prices['0'].factory.code}
                                </span>
                            </div>
                        }
                    </CardContent>
                </Collapse>
            </Card>
        );
    }
}

RecipeReviewCard.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RecipeReviewCard);